import { View, Linking } from "react-native";
import {
  ExternalLink,
  Facebook,
  Instagram,
  Linkedin,
  MessageCircle,
  Music,
  Podcast,
  Twitter,
  Youtube,
  type LucideIcon,
} from "lucide-react-native";
import type {
  ProviderSocialLink,
  ProviderSocialPlatform,
} from "@louise/providers/providers.types";
import { CompactActionButton } from "@louise/moon-ui";
import { EMBER } from "../../../onboarding/theme";

const SOCIAL_LINK_LABELS: Record<ProviderSocialPlatform, string> = {
  instagram: "Instagram",
  youtube: "YouTube",
  facebook: "Facebook",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
  x: "X",
  whatsapp: "WhatsApp",
  podcast: "Podcast",
};

const SOCIAL_LINK_ICONS: Record<ProviderSocialPlatform, LucideIcon> = {
  instagram: Instagram,
  youtube: Youtube,
  facebook: Facebook,
  tiktok: Music,
  linkedin: Linkedin,
  x: Twitter,
  whatsapp: MessageCircle,
  podcast: Podcast,
};

export function SocialLinkPills({ links }: { links: ProviderSocialLink[] }) {
  const visibleLinks = links.filter((link) => link.url);
  if (visibleLinks.length === 0) return null;

  return (
    <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
      {visibleLinks.map((link) => {
        const Icon = SOCIAL_LINK_ICONS[link.platform] ?? ExternalLink;
        const label = link.label ?? SOCIAL_LINK_LABELS[link.platform];

        return (
          <CompactActionButton
            key={`${link.platform}-${link.url}`}
            label={label}
            action="open_clinic_social_link"
            onPress={() => void Linking.openURL(link.url)}
            variant="secondary"
            leading={
              <Icon size={15} color={EMBER.colors.warm} strokeWidth={2} />
            }
            trailing={
              <ExternalLink
                size={12}
                color={EMBER.colors.textFaint}
                strokeWidth={2}
              />
            }
            numberOfLines={1}
            style={{ maxWidth: "100%" }}
            textStyle={{ maxWidth: 180 }}
          />
        );
      })}
    </View>
  );
}
